import { Component } from '@angular/core';

/**
 * Generated class for the ShoppingIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'shopping-icon',
  templateUrl: 'shopping-icon.html'
})
export class ShoppingIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/shopping-icon/shopping-icon.ts